import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { usePermission } from '@/hooks/usePermission';
import { MENU_SECTIONS } from '@/components/layout/Sidebar';
import { canAccessNavigationItem } from '@/utils/navigationAccess';
import RequirePermission from './RequirePermission';

/** 銀行担当やカスタムロールも、利用できる先頭の業務画面から開始する。 */
export function AuthorizedHome({ children }: { children: ReactNode }) {
  const { status, canRead, canWrite, canExecute } = usePermission();
  if (status === 'ready') {
    const first = MENU_SECTIONS.flatMap((section) => section.items).find(
      (item) =>
        (!item.homePermissionAnyArea || item.homePermissionAnyArea.some(canRead)) &&
        canAccessNavigationItem(item, (area, action) =>
          action === 'write'
            ? canWrite(area)
            : action === 'execute'
              ? canExecute(area)
              : canRead(area),
        ),
    );
    if (first && first.path !== '/') return <Navigate to={first.path} replace />;
  }
  // 取得中・失敗・利用可能な画面なしも共通ガードが扱う。既定権限で推測しない。
  return (
    <RequirePermission area="dashboard">
      <RequirePermission area="collections">{children}</RequirePermission>
    </RequirePermission>
  );
}
